var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-box"},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-big-play-centered video"})])}
var staticRenderFns = []

export { render, staticRenderFns }